import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class DeviceObjectReferenceEntity implements Entity {
  public static fromXML(xml) {
    return {
      entity: new DeviceObjectReferenceEntity(
        xml._attributes[ATTRS.DeviceObjectReference.DeviceObjectId]
      ),
    };
  }
  public type = TAGS.DeviceObjectReference;

  constructor(public objectId: string) {}

  public toXML() {
    return {
      _attributes: {
        [ATTRS.DeviceObjectReference.DeviceObjectId]: this.objectId,
      },
    };
  }
}
